import "init/jiffy";
import "common/base";

import { createApp } from "vue";
import { isProduction } from "common/utils/env";
import i18n from "components/jiffy/vue-cart/vue-i18n";
import paymentOverlay from "components/checkout_v2/payment-overlay/payment-overlay";
import { readCookie, deleteCookie } from "common/utils/cookie";
import PodBuildOrder from "./PodBuildOrder.vue";
import store from "./store/store";
import "common/payment/load-express-checkout-paypal-buttons";
import "common/payment/load-express-checkout-stripe-buttons";
import "components/spinner/component";
import "./reset.scss";
import "components/pod/flash-messages/flash-messages";

const initBuilderApp = () => {
  const builderSelector = "#js-build-order";
  const app = createApp({});
  app.component("PodBuildOrder", PodBuildOrder);
  app.use(store);
  app.use(i18n);
  app.mount(builderSelector);
  store.dispatch("artwork/createDtfChannel");
  store.commit("delivery/setEstimatedDeliveryDate", {
    full: window.jiffy_made_initial_delivery?.composition_dates?.value_full,
    timeleft: window.jiffy_made_initial_delivery?.composition_dates?.timeleft
  });
  store.commit("setConfig", window.jiffy_made_config);

  const orderProduct = window.jiffy_made_order_product;
  if (orderProduct?.id) {
    store.dispatch("product/fetchProduct", orderProduct);
  }

  const exploreProductComposition = readCookie("explore_product_composition");
  if (exploreProductComposition && !orderProduct) {
    try {
      const exploreProduct = JSON.parse(exploreProductComposition);
      store.commit("product/setInitialSelection", exploreProduct);
    } catch (error) {
      console.warn(error);
    } finally {
      deleteCookie("explore_product_composition");
    }
  }

  if (!isProduction()) store.commit("errors/enableErrors");
};

const handlePageShow = () => {
  window.addEventListener("pageshow", event => {
    if (event.persisted) {
      paymentOverlay.hide();
    }
  });
};

export default () => {
  initBuilderApp();
  handlePageShow();
};
